import { Amount, AmountUnit } from '../models';
import PWCore from '..';
const FEE_BASE = 1000;
export class Builder {
    constructor(feeRate = Builder.MIN_FEE_RATE, collector = PWCore.defaultCollector, witnessArgs = Builder.WITNESS_ARGS.Secp256k1) {
        this.feeRate = feeRate;
        this.collector = collector;
        this.witnessArgs = witnessArgs;
    }
    static calcFee(tx, feeRate = Builder.MIN_FEE_RATE) {
        if (feeRate < Builder.MIN_FEE_RATE) {
            feeRate = Builder.MIN_FEE_RATE;
        }
        const txSize = tx.getSize();
        const fee = (feeRate / FEE_BASE) * txSize;
        return new Amount(fee.toString(), AmountUnit.shannon);
    }
    getFee() {
        return this.fee;
    }
}
Builder.MIN_FEE_RATE = 1000;
Builder.MIN_CHANGE = new Amount('61', AmountUnit.ckb);
Builder.WITNESS_ARGS = {
    Secp256k1: {
        lock: '0x' + '0'.repeat(132),
        input_type: '',
        output_type: '',
    },
    RawSecp256k1: {
        lock: '0x' + '0'.repeat(130),
        input_type: '',
        output_type: '',
    },
    Secp256r1: {
        lock: '0x' + '0'.repeat(600),
        input_type: '',
        output_type: '',
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYnVpbGRlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9idWlsZGVycy9idWlsZGVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUNBLE9BQU8sRUFBRSxNQUFNLEVBQUUsVUFBVSxFQUFlLE1BQU0sV0FBVyxDQUFDO0FBRTVELE9BQU8sTUFBTSxNQUFNLElBQUksQ0FBQztBQUd4QixNQUFNLFFBQVEsR0FBRyxJQUFJLENBQUM7QUFRdEIsTUFBTSxPQUFnQixPQUFPO0lBbUMzQixZQUNZLFVBQWtCLE9BQU8sQ0FBQyxZQUFZLEVBQ3RDLFlBQXVDLE1BQU0sQ0FBQyxnQkFBZ0IsRUFDOUQsY0FBMkIsT0FBTyxDQUFDLFlBQVksQ0FBQyxTQUFTO1FBRnpELFlBQU8sR0FBUCxPQUFPLENBQStCO1FBQ3RDLGNBQVMsR0FBVCxTQUFTLENBQXFEO1FBQzlELGdCQUFXLEdBQVgsV0FBVyxDQUE4QztJQUNsRSxDQUFDO0lBbEJKLE1BQU0sQ0FBQyxPQUFPLENBQ1osRUFBZSxFQUNmLFVBQWtCLE9BQU8sQ0FBQyxZQUFZO1FBRXRDLElBQUksT0FBTyxHQUFHLE9BQU8sQ0FBQyxZQUFZLEVBQUU7WUFDbEMsT0FBTyxHQUFHLE9BQU8sQ0FBQyxZQUFZLENBQUM7U0FDaEM7UUFDRCxNQUFNLE1BQU0sR0FBRyxFQUFFLENBQUMsT0FBTyxFQUFFLENBQUM7UUFDNUIsTUFBTSxHQUFHLEdBQUcsQ0FBQyxPQUFPLEdBQUcsUUFBUSxDQUFDLEdBQUcsTUFBTSxDQUFDO1FBQzFDLE9BQU8sSUFBSSxNQUFNLENBQUMsR0FBRyxDQUFDLFFBQVEsRUFBRSxFQUFFLFVBQVUsQ0FBQyxPQUFPLENBQUMsQ0FBQztJQUN4RCxDQUFDO0lBVUQsTUFBTTtRQUNKLE9BQU8sSUFBSSxDQUFDLEdBQUcsQ0FBQztJQUNsQixDQUFDOztBQTFDZSxvQkFBWSxHQUFHLElBQUksQ0FBQztBQUNwQixrQkFBVSxHQUFHLElBQUksTUFBTSxDQUFDLElBQUksRUFBRSxVQUFVLENBQUMsR0FBRyxDQUFDLENBQUM7QUFDOUMsb0JBQVksR0FBRztJQUM3QixTQUFTLEVBQUU7UUFDVCxJQUFJLEVBQUUsSUFBSSxHQUFHLEdBQUcsQ0FBQyxNQUFNLENBQUMsR0FBRyxDQUFDO1FBQzVCLFVBQVUsRUFBRSxFQUFFO1FBQ2QsV0FBVyxFQUFFLEVBQUU7S0FDaEI7SUFDRCxZQUFZLEVBQUU7UUFDWixJQUFJLEVBQUUsSUFBSSxHQUFHLEdBQUcsQ0FBQyxNQUFNLENBQUMsR0FBRyxDQUFDO1FBQzVCLFVBQVUsRUFBRSxFQUFFO1FBQ2QsV0FBVyxFQUFFLEVBQUU7S0FDaEI7SUFDRCxTQUFTLEVBQUU7UUFDVCxJQUFJLEVBQUUsSUFBSSxHQUFHLEdBQUcsQ0FBQyxNQUFNLENBQUMsR0FBRyxDQUFDO1FBQzVCLFVBQVUsRUFBRSxFQUFFO1FBQ2QsV0FBVyxFQUFFLEVBQUU7S0FDaEI7Q0FDRixDQUFDIn0=